import { effect, inject, untracked } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Runs `clear` whenever the signed-in user changes (sign-out, or another account signs in), so nothing cached
 * for one user is shown to the next. Call from a constructor or field initialiser of a root service.
 */
export function clearOnUserChange(clear: () => void): void {
  const auth = inject(AuthService);
  let userId = auth.currentUser()?.id ?? null;

  effect(() => {
    const current = auth.currentUser()?.id ?? null;
    untracked(() => {
      if (current !== userId) {
        userId = current;
        clear();
      }
    });
  });
}
